import { render, staticRenderFns } from "./StationSinglesListTable.component.vue?vue&type=template&id=8c2cbaf4"
import script from "./StationSinglesListTable.component.vue?vue&type=script&lang=ts"
export * from "./StationSinglesListTable.component.vue?vue&type=script&lang=ts"
import style0 from "./StationSinglesListTable.component.vue?vue&type=style&index=0&id=8c2cbaf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
